<template>
  <div class="contact bg-white">
    <navbar @clearBody="clearContactBody"/>

    <div class="lower-mv" :style="lowermv">
      <h2>{{$t('contact')}}</h2>
    </div>

    <section class="wrapper">
      <p class="intro" v-html="$t('contact1')">
      <form>
        <div class="contact-input-wrapper input-form">
          <Editor v-model="body" :api-key="getTinyConfig.api_key"  :init="{
            menubar: false,
            statusbar: false,
            toolbar: false}"
          />
        </div>
        <div class="submit">
          <button type="button" class="brown_btn" @click="sendEmailData"><i class="icon-submit" :style="iconMail"></i><span>{{ $t('send') }}</span></button>
        </div>
      </form>
    </section>
     <footerClient />
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import appConfig from '../../../api/api'
import navbar from '@/components/client/navbar'
import footerClient from '@/components/client/footerClient'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      body: null,
      lowermv: {
        background: `url(${require('@/assets/img/client/lower_mvbg.jpg')}) center / cover`
      },
      iconMail: {
        background: `url(${require('@/assets/img/client/icon-submit.png')}) left top / 23px 44px no-repeat`
      }
    }
  },
  components: {
    navbar,
    footerClient,
    Editor
  },
  computed: {
    getTinyConfig: function () {
      return appConfig
    }
  },
  created () {
    this.bodyContact()
  },
  methods: {
    ...mapActions('contactUs', ['sendEmail']),
    bodyContact: function () {
      const name = this.$route.query.name
      let newBody = null
      if (this.$route.params.lang === 'ja') {
        newBody = name + ' ' + this.$i18n.t('about') + '<br>-----------------------------------------'
      } else {
        newBody = this.$i18n.t('about') + ' ' + name + '<br>-----------------------------------------'
      }
      if (name) {
        this.body = newBody
      } else {
        this.body = ''
      }
    },
    sendEmailData: function () {
      const bodyData = { body: this.body }
      this.sendEmail(bodyData)
    },
    clearContactBody (value) {
      this.body = ''
    }
  }
}
</script>
